import React, { Component } from 'react'
import classnames from 'classnames'
import { Field, reduxForm } from 'redux-form'

import LoaderButton from '../../components/loaderButton'
import { Loan, Rule } from './types'
import { ReduxFormProps } from '../../forms'

export interface Props {
  loan: Loan
}

export interface FormProps {
  ruleWaivers: object
  adminNote: string
}

export class RuleForm extends Component<ReduxFormProps<Props, FormProps>> {
  renderRule = (rule: Rule, index: number) => {
    if (!rule) return null

    const { name, status } = rule

    return (
      <tr key={index}>
        <td>{name}</td>
        <td>{status}</td>
        <td>
          <Field
            name={`ruleWaivers.${name}`}
            component="input"
            type="checkbox"
          />
        </td>
      </tr>
    )
  }

  render() {
    const { loan, handleSubmit, submitting } = this.props
    if (!loan) return null

    const { rules } = loan

    const tableRows = rules.map(this.renderRule)

    let disabled = loan.adminStatus === 'EXPIRED'

    return (
      <form
        className="form"
        name="underwritingRuleForm"
        onSubmit={handleSubmit}
      >
        <table className="table rounded-table table-striped-column rule-waiver-table">
          <thead>
            <tr>
              <th>name</th>
              <th>status</th>
              <th>waive</th>
            </tr>
          </thead>
          <tbody>{tableRows}</tbody>
        </table>
        <div className="loan-buttons">
          <Field
            type="text"
            component="input"
            className="admin-note"
            name="adminNote"
            placeholder="Admin Note"
          />
          <LoaderButton
            type="submit"
            disabled={disabled}
            className={classnames('button __form__button--submit', {
              'button--primary': !disabled,
              'button--disabled': disabled,
            })}
            isLoading={submitting}
          >
            Redecision
          </LoaderButton>
        </div>
      </form>
    )
  }
}

export default reduxForm<FormProps, Props>({
  form: 'underwritingRuleForm',
  enableReinitialize: true,
  destroyOnUnmount: true,
})(RuleForm)
